import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { placeholderMembersApi } from 'src/Services/API';
import { PlaceholderMemberDto } from 'src/Services/API/generated';
import { trackPlaceholderMemberFused } from 'src/Services/Mixpanel/events';
import { ApiError } from 'src/types/api-error.types';

interface FuseVariables {
  placeholderId: string;
  assetId: string;
}

export const useFusePlaceholderMember = () => {
  const queryClient = useQueryClient();

  return useMutation<PlaceholderMemberDto, AxiosError<ApiError>, FuseVariables>({
    mutationFn: async ({ placeholderId }) =>
      (await placeholderMembersApi.placeholderMembersControllerFuse(placeholderId)).data,
    onSuccess: (_data, { placeholderId, assetId }) => {
      trackPlaceholderMemberFused({
        asset_id: assetId,
        placeholder_id: placeholderId,
        trigger: 'signup_auto',
      });
      queryClient.invalidateQueries(['fetch-pending-placeholder-matches']);
      queryClient.invalidateQueries(['fetch-members']);
      queryClient.invalidateQueries(['fetch-assets']);
    },
  });
};
